import { configureStore } from "@reduxjs/toolkit";
import members from "./reducers/members";
import routes from "./reducers/routes";

const store = configureStore({
  reducer: {
    members,
    routes,
  },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
